import type { Dons } from '@/types/Contenu'

// Numéros Mobile Money officiels du CMP Lubumbashi — valeurs initiales, modifiables depuis /admin.
export const DONS_INITIAUX: Dons = {
  mobileMoney: [
    { id: 'airtel', operateur: 'airtel', libelle: 'Airtel Money', numero: '097 090 39 40' },
    { id: 'orange', operateur: 'orange', libelle: 'Orange Money', numero: '089 89 27 266' },
    { id: 'mpesa', operateur: 'mpesa', libelle: 'M-Pesa', numero: '08942' },
  ],
  // Coordonnées bancaires — pour les dons depuis l'étranger (diaspora).
  compteBancaire: {
    banque: 'Equity Bank',
    numero: '00018000160112928120032',
  },
}
